import { GlBadge, GlTooltipDirective } from '@gitlab/ui';
import { s__ } from '~/locale';
export default {
    name: 'ImportedBadge',
    tooltip: s__('BulkImport|This item was imported from another instance.'),
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        textOnly: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
